export function safeURIDecode(val) {
  try {
    return decodeURIComponent(val);
  } catch {
    return val; // fallback to raw value if decoding fails
  }
}

export async function fetchWithErrorHandling(
  url,
  options,
  errorMsg = "An unexpected error occurred. Please try again later."
) {
  const response = await fetch(url, options);
  if (!response.ok) {
    let message = errorMsg;
    if (response.status >= 500) {
      message = "Server error. Please try again later.";
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function getAesKeyFromString(passphrase) {
  const encoder = new TextEncoder();
  const passphraseKey = encoder.encode(passphrase);
  const hashBuffer = await crypto.subtle.digest("SHA-256", passphraseKey);
  return crypto.subtle.importKey(
    "raw",
    hashBuffer,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );
}

export async function decryptData(base64String, passphrase) {
  const encryptedBytes = Uint8Array.from(atob(base64String), (c) =>
    c.charCodeAt(0)
  );

  // Extract IV and ciphertext+tag
  const iv = encryptedBytes.slice(0, 12); // First 12 bytes
  const ciphertext = encryptedBytes.slice(12); // Rest is ciphertext+tag

  const key = await getAesKeyFromString(passphrase);

  try {
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      ciphertext
    );
    return new TextDecoder().decode(decryptedBuffer);
  } catch (e) {
    console.error("Decryption failed:", e);
    return null;
  }
}
